import { Avatar as avatarImage, ChapterLogo } from "~/common/assets";
import {
  Avatar,
  ImagePromptCard,
  LoadingState,
  WaveBackgroundLayout,
} from "~/common/components";

interface ConsultationCompletedProps {
  handleContinue: () => void;
  content: React.ReactNode;
  profilePicturePath?: string;
  isLoading?: boolean;
}

export const ConsultationIntroScreen = ({
  handleContinue,
  content,
  profilePicturePath,
  isLoading = false,
}: ConsultationCompletedProps) => {
  if (isLoading) return <LoadingState />;

  return (
    <WaveBackgroundLayout className="relative p-6 md:gap-0">
      <div className="flex flex-col items-center py-8">
        <img src={ChapterLogo} alt="Chapter logo" className="w-full" />
      </div>
      <ImagePromptCard
        handleContinue={handleContinue}
        pendingContinue={false}
        continueLabel="Got it!"
        imageContainerClassName="bg-primary-30"
        content={content}
      >
        <Avatar
          className="size-full"
          src={profilePicturePath ?? avatarImage}
          alt="Provider"
        />
      </ImagePromptCard>
    </WaveBackgroundLayout>
  );
};
